import React from 'react';
export function GuaranteeBlock() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-217">
      <div className="max-w-3xl mx-auto text-center" data-id="element-218">
        <div className="text-6xl md:text-7xl mb-6 flex justify-center" data-id="element-219">🛡️</div>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-220">
          Garantía de 7 días — Sin preguntas
        </h2>
        <h3 className="text-xl md:text-2xl font-bold text-green-600 mb-6" data-id="element-221">
          Te devolvemos el 100%.
        </h3>
        <p className="text-lg text-slate-600 max-w-xl mx-auto" data-id="element-222">
          Si en 7 días no es lo que esperabas, escribinos y listo. Sin
          formularios. Sin drama.
        </p>
      </div>
    </section>;
}